import { createFileRoute } from '@tanstack/react-router'
import { PaymentsLogPage } from '@/features/finance/payments-log/pages/payments-log-page'
import type { PaymentLogScope } from '@/features/finance/payments-log/types/payments-log.types'

const resellerPaymentScopes = new Set<PaymentLogScope>([
  'self_gateway',
  'customer_gateway',
  'allocation',
])

export const Route = createFileRoute('/_authenticated/reseller/finance/payments')({
  validateSearch: (search: Record<string, unknown>) => {
    const raw = typeof search.scope === 'string' ? search.scope : ''
    const scope = resellerPaymentScopes.has(raw as PaymentLogScope)
      ? (raw as PaymentLogScope)
      : undefined
    return { scope }
  },
  component: ResellerPaymentsPage,
})

function ResellerPaymentsPage() {
  const { scope } = Route.useSearch()
  return <PaymentsLogPage role='reseller' initialScope={scope} />
}
